<template>
  <div style="padding-bottom:0px;" class="AppSlider">
    <b-carousel 
      v-if="computedScreenWidth"
      id="carousel-1"
      v-model="slide"
      :interval="10000"
      background="#ababab"
      img-width="1280"
      img-height="600"
      fade
      style="text-shadow: 1px 1px 2px #333;"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <!-- Text slides with image -->
      <b-carousel-slide
        v-for="(image,index)  in codedImages.carousel.mobile"
        :key="index"
      >
        <template v-slot:img>
          <img
            class="d-block img-fluid w-100 myimage"
            :src="image.img"
            alt="image slot"
          >
          <div class="ad_section_header">{{ image.heading }}</div>
          <div class="ad_section_sub_header text_section">{{ image.sub_heading }}</div>
          <div class="ad_section_content text_section">{{ image.content }}</div>
          <div class="ad_section_sub_content text_section">{{ image.sub_content }}</div>
          <p v-if="image.key==0"><button @click="downloadApp" class="btn btn-large text_section">{{ image.btn_text }}</button></p>
          <p v-else><button @click="openDrawer(image.key)" class="btn btn-large text_section">{{ image.btn_text }}</button></p>
        </template>
      </b-carousel-slide>
    </b-carousel>
    <b-carousel 
      v-else
      id="carousel-1"
      v-model="slide"
      :interval="10000"
      background="#ababab"
      img-width="1280"
      img-height="600"
      fade
      style="text-shadow: 1px 1px 2px #333;"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <!-- Text slides with image -->
      <b-carousel-slide
        v-for="(image,index)  in codedImages.carousel.desktop"
        :key="index"
      >
        <template v-slot:img>
          <img
            class="d-block img-fluid w-100 AppSlider_image"
            :src="image.img"
            alt="image slot"
          >
          <div class="ad_section_header">{{ image.heading }}</div>
          <div class="ad_section_sub_header text_section">{{ image.sub_heading }}</div>
          <div class="ad_section_content text_section">{{ image.content }}</div>
          <div class="ad_section_sub_content text_section">{{ image.sub_content }}</div>
          <p v-if="image.key==0"><button @click="downloadApp" class="btn btn-large text_section">{{ image.btn_text }}</button></p>
          <p v-else><button @click="openDrawer(image.key)" class="btn btn-large text_section">{{ image.btn_text }}</button></p>
        </template>
      </b-carousel-slide>
    </b-carousel>
    <div class="AppSlider__controls">
      <button
        class="AppSlider__control"
        @click="prev"
      >
        &laquo; 
      </button>
      <button
        class="AppSlider__control__right"
        @click="next"
      >
        &raquo;
      </button>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import VueScreenSize from 'vue-screen-size';

  export default {
    data() {
      return {
        slide: 0,
        sliding: null
      }
    },
    mixins: [
      VueScreenSize.VueScreenSizeMixin
    ],
    methods: {
      onSlideStart(slide) {
        if (slide)
        this.sliding = true
      },
      onSlideEnd(slide) {
        if (slide)
        this.sliding = false
      },
      openDrawer(key){
        var index = 0;

        if (key==1){
          index = key;
        }else if(key==2){
          index = key;
        }else if (key==3){
          index = 5
        }

        this.components.nav_drawer.product_index=index;
        this.components.nav_drawer.mini_variant=false;
        this.components.nav_drawer.expand_on_hover=false;        
      },
      openBottomSheet(index){
        this.components.bottom_sheet.option_index=index;
        this.components.bottom_sheet.is_open=true;      
      },
      downloadApp(){
        this.$router.push('/mobile_app');
      },
      goToIndex(index) {
        this.activeIndex = index;
      },
      next() {
        /*let nextIndex = this.activeIndex + 1;
        if (!this.images[nextIndex]) {
          nextIndex = 0;
        }

        this.goToIndex(nextIndex);*/
        //this.onSlideStart();
      },
      prev() {
        let nextIndex = this.activeIndex - 1;

        if (!this.images[nextIndex]) {
          nextIndex = this.images.length - 1;
        }

        this.goToIndex(nextIndex);
      },
    },
    computed: {
     ...mapGetters({
        user: "user",
        components: "components",
        codedImages: "codedImages"
      }),
      computedScreenWidth () {
        var go_mobile = false;
        if (this.$vssWidth < 600){
          go_mobile = true;
        }
        return go_mobile;
      },
    }
  }
</script>
<style scoped lang="scss">
  .myimage {
    filter: brightness(50%);
  }
  /* Ad Section */
  .ad_section_header {
    position: absolute;
    top: 40%;
    left: 10%;
    color:lightgray;
    font-size:7vw;
    font-family:'Roboto';
    font-weight: 100;
  }
  .ad_section_sub_header {
    position: absolute;
    top: 47%;
    left: 10%;
    color:lightgray;
    font-size:7vw;
    font-family:'Roboto';
    font-weight: 100;
  }
  .ad_section_content {
    position: absolute;
    top: 55%;
    left: 10%;
    color:lightgray;
    font-size:0vw;
    font-family:'Verdana';
    
  }
  .ad_section_sub_content {
    position: absolute;
    top: 58%;
    left: 10%;
    color:lightgray;
    font-size:0vw;
    font-family:'Verdana';
  }
  .btn {
    position: absolute;
    top: 67%;
    left: 30%;
    background-color: transparent;
    color: lightgray;
    border: 1px solid lightgray;
    padding: 10px;
    font-size: 1.2em;
        
    &:hover {
      color: #C57ED3;
      border-color: #C57ED3;
    }
    .appear{
      color: red;
    }
  }
  @media only screen and (min-width: 600px) {
    .ad_section_header {
    position: absolute;
    top: 32%;
    left: 10%;
    color:lightgrey;
    font-size:7vh;
    font-family:'Roboto';
    font-weight: 100;
  }
  .ad_section_sub_header {
    position: absolute;
    top: 42%;
    left: 10%;
    color:lightgrey;
    font-size:7vh;
    font-family:'Roboto';
    font-weight: 100;
  }
  .ad_section_content {
    position: absolute;
    top: 55%;
    left: 10%;
    color:lightgray;
    font-size:2vh;
    font-family:'Verdana';
    font-weight: 100;
  }
  .ad_section_sub_content {
    position: absolute;
    top: 58%;
    left: 10%;
    color:lightgray;
    font-size:2vh;
    font-family:'Verdana';
    font-weight: 100;
  }
  .btn {
    position: absolute;
    top: 65%;
    left: 22%;
    background-color: transparent;
    color: lightgray;
    border: 1px solid lightgray;
    padding: 10px;
    font-size: 1.2em;
        
    &:hover {
      color: #C57ED3;
      border-color: #C57ED3;
    }
    .appear{
      color: red;
    }
  }
}
</style>